import React, { useState } from 'react';
import { Bar, Chart } from "react-chartjs-2";
import {
    ResponsiveContainer,
} from 'recharts';
import pageHint from '@images/info.svg';
import Separator from "@components/Separator";
import styles from "./stackedbarchart.module.css";

const COLORS = [
    "#00BA88", // Teal
    "#669FF6", // Light Blue
    "#7381EA", // Periwinkle
    "#FF7F50", // Coral
    "#FFD476", // Light Orange
    "#A17FEF", // Purple
    "#FF3407", // Bright Red
    "#4CAF50", // Green
    "#FF9800", // Orange
    "#E91E63", // Pink
    "#2196F3", // Blue
    "#9C27B0", // Deep Purple
    "#FFC107", // Amber
    "#00BCD4", // Cyan
    "#795548", // Brown
    "#607D8B", // Blue Grey
    "#F44336", // Red
    "#3F51B5", // Indigo
    "#8BC34A", // Light Green
    "#009688"  // Teal Green
];

export default function StackedBarChartWidget(props) {

    const transformData = (data) => {
        return {
            labels: data.labels,
            datasets: data?.datasets?.map((dataset, index) => ({
                minBarLength: 3,
                label: dataset.label,
                data: dataset.dataSet,
                backgroundColor: COLORS[index],
                borderColor: COLORS[index],
                borderWidth: 3,
                barThickness: 'flex',
                maxBarThickness: 50,
                borderRadius: 10
            }))
        };
    };

    const [barData] = useState(transformData(props.data));

    const [barOptions] = useState({
        scales: {
            x: {
                stacked: ((props.xstacked !== undefined && props.xstacked !== null) ? props.xstacked : false),
                ticks: {
                    display: true,
                    maxRotation: 0,
                    minRotation: 0,
                    callback: function (value) {
                        const label = this.getLabelForValue(value);
                        const words = label.split(' ');
                        return words.length > 2
                            ? words.slice(0, 2).join(' ') + '...'
                            : label;
                    }
                },
                grid: {
                    display: true
                }
            },
            y: {
                stacked: ((props.ystacked !== undefined && props.ystacked !== null) ? props.ystacked : false),
                beginAtZero: true,
                grid: {
                    borderDash: [2, 2]
                }
            }
        },
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: (props.legendPosition !== undefined && props.legendPosition !== null)
                    ? props.legendPosition
                    : "bottom",
                align: 'start',
                maxWidth: 300,
                labels: {
                    boxWidth: 20,
                    padding: 10,
                    font: {
                        size: 12,
                        lineHeight: 1.2
                    },
                    textAlign: 'left',
                    color: '#666',
                    boxHeight: 8,
                    usePointStyle: true,
                    pointStyle: 'rect'
                }
            },
            tooltip: {
                callbacks: {
                    title: function (tooltipItems) {
                        // Show full label text in tooltip
                        return barData.labels[tooltipItems[0].dataIndex];
                    },
                    label: function (context) {
                        return `${context.dataset.label}: ${context.raw}`;
                    }
                }
            }
        },
        layout: {
            padding: {
                right: 30,
                left: 10,
                top: 20,
                bottom: 10
            }
        },
        responsive: true
    });

    return (
        <React.Fragment>
            <div className={styles.featuredItem}>
                <span className={styles.featuredTitleHeader}>
                    {props.headerTitle}
                    <span className="pageHint">
                        <img src={pageHint} alt="" />
                        <span className="tooltiptext">{props.toolTip}</span>
                    </span>
                </span>
                <Separator />
                <span className={styles.featuredTitle}>{props.title}</span>
                <br />
                <span className={styles.featuredSub}>{props.subTitle}</span>

                <div className={styles.featuredTextContainer}>
                    <ResponsiveContainer width="99%" aspect={2}> {/* Using aspect ratio instead of fixed height */}
                        <Bar
                            data={barData}
                            options={barOptions}
                        />
                    </ResponsiveContainer>
                </div>
            </div>


        </React.Fragment>
    );
}
